module.exports = __webpack_public_path__ + "static/img/wxkf.9d316fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wxkf.jpg
// module id = EPYp
// module chunks = 1